<script setup lang="ts">
const props = withDefaults(defineProps<{
  modelValue?: boolean
  isClosedAllowed?: boolean
  stickToBottom?: boolean
  noPadding?: boolean
  noCloseButton?: boolean
  unlimitedWidth?: boolean
}>(), {
  isClosedAllowed: true,
})

const emit = defineEmits(['update:modelValue', 'close'])

function close() {
  if (props.isClosedAllowed) {
    emit('update:modelValue', false)
    emit('close')
  }
}

function onEscape(e) {
  if (props.isClosedAllowed && props.modelValue && e?.keyCode === 27) close()
}

onUpdated(() => {
  document?.addEventListener('keydown', onEscape, { once: true })
})
</script>

<template>
  <teleport v-if="modelValue" to="body">
    <div
      id="base-modal-overlay"
      class="z-50 fixed top-0 left-0 bg-opacity-60 bg-black w-full h-full flex justify-center"
      :class="[stickToBottom ? 'items-end' : 'items-center']"
      @click="close"
    >
      <div
        id="base-modal-content"
        class="border-1 gap-4 bg-white border-gray shadow rounded-xl max-h-11/12 overflow-auto relative"
        :class="[stickToBottom ? 'm-0' : 'm-4', { 'p-5': !noPadding }, { 'sm:max-w-600px': !unlimitedWidth }]"
        role="dialog"
        @click.stop
      >
        <div class="flex justify-between items-start gap-4">
          <div>
            <slot name="header" />
          </div>

          <button v-if="isClosedAllowed && !noCloseButton" class="flex-shrink-0" type="button" @click="close">
            <AppIcon size="19" icon="far-times" />
          </button>
        </div>

        <slot name="content" />

        <slot name="footer" />
      </div>
    </div>
  </teleport>
</template>
